import React, { useState, useEffect } from "react"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import { detailsGdd } from "../templates/details/styles/detailsGdd.module.scss"
import { listGdd, titleGdd } from "../templates/list/styles/listGdd.module.scss"
import PropTypes from "prop-types"
import {
  StyledSection,
  BandeauStyled,
} from "../templates/details/styled-components/gdd-styled"
import ReactHtmlParser, { processNodes } from "react-html-parser"

const HtmlParser = ({ content, anchor }) => {
  if (!content) return null

  const calculateLevel = (node) => {
    let level = 0
    let currentNode = node

    // On remonte la hiérarchie des nœuds pour compter les niveaux de li/ul
    while (currentNode.parent) {
      if (currentNode.name === "li") {
        level++
      }
      currentNode = currentNode.parent
    }

    return level
  }

  const handleMouseEnter = (event) => {
    const isFirstLevel = event.target.querySelector("a[aria-expanded]")
    if (isFirstLevel !== null) {
      isFirstLevel.setAttribute("aria-expanded", "true")
    }
  }

  const handleMouseLeave = (event) => {
    const isFirstLevel = event.target.querySelector("a[aria-expanded]")
    if (isFirstLevel !== null) {
      isFirstLevel.setAttribute("aria-expanded", "false")
    }
  }

  const handleOnFocus = (event) => {
    const isFirstLevel = event.target.querySelector("a[aria-expanded]")
    const isSecondLevel = event.target.querySelector("button[aria-expanded]")

    if (isSecondLevel !== null && isFirstLevel === null) {
      isSecondLevel.setAttribute("aria-expanded", "true")
    }
  }

  const handleOnBlur = (event) => {
    const isFirstLevel = event.target.querySelector("a[aria-expanded]")
    const isSecondLevel = event.target.querySelector("button[aria-expanded]")

    if (isSecondLevel !== null && isFirstLevel === null) {
      isSecondLevel.setAttribute("aria-expanded", "false")
    }
  }
  const mainAnchor = ["#top", "#main", "#search-button", "#footer", "#menu"]

  return new ReactHtmlParser(content, {
    transform: function transform(node, elementIndex) {
      if (mainAnchor.includes(anchor)) {
        if (node.type === "tag" && node.name === "li") {
          return (
            <React.Fragment key={elementIndex}>
              <li
                tabIndex={elementIndex}
                onMouseEnter={handleMouseEnter}
                onFocus={handleOnFocus}
                onMouseLeave={handleMouseLeave}
                onBlur={handleOnBlur}
              >
                {processNodes(node.children, transform)}
              </li>
            </React.Fragment>
          )
        }
        if (node.type === "tag" && node.name === "a") {
          const level = calculateLevel(node)
          return (
            <p>
              {level === 3 && (
                <a
                  key={elementIndex}
                  href={"#" + node.attribs.href.split("/")[2]}
                >
                  {processNodes(node.children, transform)}
                </a>
              )}
              {level === 2 && (
                <button key={elementIndex} aria-expanded={false}>
                  {processNodes(node.children, transform)}
                </button>
              )}
              {level === 1 && (
                <a
                  key={elementIndex}
                  href={"#" + node.attribs.href.split("/")[2]}
                  aria-expanded={false}
                >
                  {processNodes(node.children, transform)}
                </a>
              )}
            </p>
          )
        }
      } else {
        if (node.type === "tag" && node.name === "h1") {
          return <h2>{processNodes(node.children, transform)}</h2>
        }
        if (node.type === "tag" && node.name === "h2") {
          return <h3>{processNodes(node.children, transform)}</h3>
        }
        // On désactive les liens qui n'ont pas de page correspondante
        if (
          node.type === "tag" &&
          node.name === "a" &&
          !node.next &&
          !node.previous &&
          node.parent &&
          node.parent.parent &&
          node.parent.parent.parent &&
          !node.parent.parent.parent.parent
        ) {
          return (
            <p>
              <a>{processNodes(node.children, transform)}</a>
            </p>
          )
        }
        if (node.type === "tag" && node.name === "a") {
          if (!node.parent || node.parent.name === "h2") {
            const internalLinkRegex = /\/Particuliers\//
            if (internalLinkRegex.test(node.attribs.href)) {
              return (
                <p>
                  <a
                    key={elementIndex}
                    href={"#" + node.attribs.href.split("/")[2]}
                  >
                    {processNodes(node.children, transform)}
                  </a>
                </p>
              )
            }
            return (
              <p>
                <a
                  key={elementIndex}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={node.attribs.href}
                >
                  {processNodes(node.children, transform)}
                </a>
              </p>
            )
          }

          return (
            <a key={elementIndex} href={"#" + node.attribs.href.split("/")[2]}>
              {processNodes(node.children, transform)}
            </a>
          )
        }
      }
    },
  })
}

const GddTemplate = (location) => {
  const [anchor, setAnchor] = useState(
    location.location.hash ? location.location.hash : "#menu"
  )
  const [content, setContent] = useState("")

  useEffect(() => {
    const onHashChange = (event) => {
      let newAnchor = event.newURL.split("#")[1]
      if (!newAnchor) newAnchor = "menu"
      setAnchor("#" + newAnchor)
    }
    window.addEventListener("hashchange", onHashChange)
    return () => {
      window.removeEventListener("hashchange", onHashChange)
    }
  }, [])
  const mainAnchor = ["#top", "#main", "#search-button", "#footer", "#menu"]

  useEffect(() => {
    let pageToFetch = anchor
    if (!pageToFetch || mainAnchor.includes(pageToFetch)) pageToFetch = "menu"
    else pageToFetch = pageToFetch.split("#")[1]
    fetch(process.env.GDD_CONTENT_URL + `/Particuliers/${pageToFetch}.html`)
      .then((result) => {
        return result.text()
      })
      .then((html) => {
        setContent(html)
      })
  }, [anchor, mainAnchor])

  return (
    <Layout isDetail={true}>
      <SEO
        title={"Guide droits et démarches"}
        description={"Guide droits et démarches"}
      />
      <div className="headerGDD">
        <h1 className={titleGdd}>
          GUIDE<br></br>« VOS DROITS ET DÉMARCHES »<br></br>POUR LES
          PARTICULIERS
        </h1>
        <BandeauStyled aria-hidden={true} />
      </div>
      <div id="gdd-content">
        {!location.location.hash ||
        mainAnchor.includes(location.location.hash) ? (
          <StyledSection className={listGdd}>
            <HtmlParser content={content} anchor={anchor} />
          </StyledSection>
        ) : (
          <StyledSection className={detailsGdd}>
            <HtmlParser content={content} anchor={anchor} />
          </StyledSection>
        )}
      </div>
    </Layout>
  )
}

HtmlParser.propTypes = {
  content: PropTypes.object,
  anchor: PropTypes.string,
}

GddTemplate.propTypes = {
  location: PropTypes.object,
}

export default GddTemplate
